import { aggRulesWeightDefaults } from "./index153.js";
import { getDefaultMix } from "@project-rouge/rg-core";
function getDefaultAggRulesProps(dataset) {
	return {
		targetUnitMix: getDefaultMix(dataset),
		canCloseEnds: [true, true],
		targetEntranceCount: 0,
		hasEntryAtStart: false,
		hasCornerAt: [false, false],
		distToCore: [0, 0],
		targetFireCoreCount: 0,
		targetLiftCoreCount: 0,
		targetStairCoreCount: 0,
		skipCores: true,
		maxCorridorDists: {
			start: dataset.aggConfig.maxTravelDistSprinklered,
			middle: dataset.aggConfig.maxTravelDistBidirectional * 2,
			end: dataset.aggConfig.maxTravelDistSprinklered
		},
		endClosingDistances: [0, 0],
		endEntranceDistances: [Infinity, Infinity],
		lockEnds: [true, false],
		weights: aggRulesWeightDefaults,
		isDoubleLoaded: true
	};
}
export { getDefaultAggRulesProps };

//# sourceMappingURL=index154.js.map